import useSiteTypeIcon from 'Checkout/Hooks/useSiteTypeIcon'
import FontAwesomeIcon from 'Checkout/Components/Shared/FontAwesomeLib'

const SiteTypeIcon = ({ siteType }) => {
  const renderIcon = () => {
    if (!siteType) return

    const { icon, img } = useSiteTypeIcon(siteType)

    if (icon) return <FontAwesomeIcon icon={icon} className="me-2" size="2xl" />

    return <img src={img} height="35" alt="" />
  }

  return (
    <div className="d-flex me-2 mx-md-2 mx-lg-3">
      {renderIcon()}
    </div>
  )
}

export default SiteTypeIcon
